import React from 'react';
import MarketingHeader from '../../components/ui/MarketingHeader';
import HeroSection from './components/HeroSection';
import ProcessGuide from './components/ProcessGuide';
import SolutionsSection from './components/SolutionsSection';
import ProductShowcase from './components/ProductShowcase';

const MarketingHome = () => {
  return (
    <div className="min-h-screen bg-background">
      <MarketingHeader />
      <main className="pt-16">
        <HeroSection />
        <ProcessGuide />
        <SolutionsSection />
        <ProductShowcase />
      </main>
      {/* Footer */}
      <footer className="bg-primary text-primary-foreground py-12 border-t border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-8 h-8 bg-accent rounded-lg flex items-center justify-center">
                  <svg 
                    width="20" 
                    height="20" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-primary"
                  >
                    <path 
                      d="M3 3h18v18H3V3zm2 2v14h14V5H5zm2 2h10v2H7V7zm0 4h10v2H7v-2zm0 4h6v2H7v-2z" 
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <span className="text-xl font-semibold">BPMLflows</span>
              </div>
              <p className="text-primary-foreground/80 mb-4 max-w-md">
                Streamline SAP Best Practices implementation with AI-powered requirements gathering, 
                automated fit/gap analysis, and digital document approval workflows.
              </p>
              <div className="text-sm text-primary-foreground/60">
                © {new Date()?.getFullYear()} BPMLflows. All rights reserved.
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-semibold mb-4">Product</h4>
              <ul className="space-y-2 text-sm text-primary-foreground/80">
                <li><a href="#" className="hover:text-accent transition-colors">Features</a></li>
                <li><a href="#" className="hover:text-accent transition-colors">Pricing</a></li>
                <li><a href="#" className="hover:text-accent transition-colors">Documentation</a></li>
                <li><a href="#" className="hover:text-accent transition-colors">API Reference</a></li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <h4 className="font-semibold mb-4">Support</h4>
              <ul className="space-y-2 text-sm text-primary-foreground/80">
                <li><a href="#" className="hover:text-accent transition-colors">Help Center</a></li>
                <li><a href="#" className="hover:text-accent transition-colors">Contact Us</a></li>
                <li><a href="#" className="hover:text-accent transition-colors">Status Page</a></li>
                <li><a href="#" className="hover:text-accent transition-colors">Security</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MarketingHome;